import { call, put, takeEvery } from 'redux-saga/effects';
import { AdvanceNewDealerRequest, NewDealerActionKeys } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { newDealerActionCreators } from '../newDealerActionCreators';
import * as api from '../newDealerApi';
import { INewDealerRequestFull } from '../newDealerInterfaces';

function* advanceNewDealerState(action: AdvanceNewDealerRequest) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>> = yield call(
    api.advanceNewDealerState,
    action.payload.newDealerRequestId
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(newDealerActionCreators.setRequest(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAdvanceNewDealerState() {
  yield takeEvery(NewDealerActionKeys.ADVANCE_NEW_DEALER_REQUEST, advanceNewDealerState);
}
